import { ReactComponent as ServiceJobTrackingIcon } from '../assets/icons/building.svg';
import { ReactComponent as EmployeeOnboardingIcon } from '../assets/icons/user-checkmark.svg';
import { ReactComponent as RFITrackingIcon } from '../assets/icons/clipboard.svg';
import { ReactComponent as BidProjectTrackingIcon } from '../assets/icons/hand.svg';
import { ReactComponent as DailyTimesheetsLEMRreportsIcon } from '../assets/icons/bar-chart.svg';
import { ReactComponent as BoardIcon } from '../assets/icons/folder.svg';
import { ReactComponent as FormIcon } from '../assets/icons/document.svg';
import { ReactComponent as CustomFieldIcon } from '../assets/icons/checkmark-box.svg';

export const listingIcons = {
  boards: BoardIcon,
  forms: FormIcon,
  customFields: CustomFieldIcon,
  building: ServiceJobTrackingIcon,
  users: EmployeeOnboardingIcon,
  clipboard: RFITrackingIcon,
  hand: BidProjectTrackingIcon,
  chart: DailyTimesheetsLEMRreportsIcon,
};

export const componentIcons = {
  boards: {
    icon: <BoardIcon />,
    color: '#E3F2FD',
  },
  forms: {
    icon: <FormIcon />,
    color: '#FCE7F3',
  },
  customFields: {
    icon: <CustomFieldIcon />,
    color: '#F3E8FF',
  },
};
